let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1QNch")).then(() => parcelRequire('7cv4i'));